export default {"src":"/_next/static/media/plan-icon-flower-maroon.5564e436.svg","height":31,"width":30,"blurWidth":0,"blurHeight":0};